

import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App'
import Vant from 'vant'
import axios from 'axios'
import 'vant/lib/index.css'
import router from './router/index.js'
import upload from './assets/js/upload.js'
import upload2 from './assets/js/upload2.js'
import getWxConfig from '@/util/getWxConfig.js'
import {getUrlParmas} from "@/util/tool"
import store from './store/index.js'
import wx from "weixin-jsapi"
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import wechatPlugin from "@/util/wechatAuth"
import { login } from "@/api/auth"

Vue.use(VueRouter)
Vue.use(WechatPlugin)
Vue.use(AjaxPlugin)
Vue.use(LoadingPlugin)
Vue.use(ToastPlugin)
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(Vant)

Vue.prototype.wx = wx
let query = getUrlParmas();
let url = 'http://hnjsdb.com/index.html?userid='+query.userid;
console.log(query.userid)

/*if(query.userid){
Vue.use(wechatPlugin, {
router, // 路由实例对象
appid: 'wx4e3f4723475cf706', // 您的微信appid

responseType: 'code', // 返回类型，请填写code
scope: 'snsapi_base', // 应用授权作用域，snsapi_base （不弹出授权页面，直接跳转，只能获取用户openid），snsapi_userinfo （弹出授权页面，可通过openid拿到昵称、性别、所在地。并且，即使在未关注的情况下，只要用户授权，也能获取其信息）
redirectUri: url, //微信回调地址
getCodeCallback (next, code) {

console.log("=================code=", code);
}
})
}*/














FastClick.attach(document.body);
Vue.config.productionTip = false;


Vue.prototype.$upload = upload;  
Vue.prototype.$upload2 = upload2;
Vue.prototype.$wxConfig = getWxConfig;


axios.defaults.withCredentials = true;

/* eslint-disable no-new */
new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-box');




(function (doc, win) {
var docEl = doc.documentElement,
resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
recalc = function () {
var clientWidth = docEl.clientWidth;
if (!clientWidth) return;
if (clientWidth >= 750) {
docEl.style.fontSize = '100px';
} else {
docEl.style.fontSize = 100 * (clientWidth / 750) + 'px';
}
};

if (!doc.addEventListener) return;
win.addEventListener(resizeEvt, recalc, false);
doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);



// WEBPACK FOOTER //
// ./src/main.js